
import { Voucher } from "@/types/voucher";
import { VoucherCard } from "./VoucherCard";

interface VouchersListProps {
  vouchers: Voucher[];
  onVoucherSelect: (voucher: Voucher) => void;
  isLoading: boolean;
}

export function VouchersList({ 
  vouchers, 
  onVoucherSelect,
  isLoading 
}: VouchersListProps) {
  if (isLoading) {
    return (
      <div className="flex flex-col space-y-4 py-8">
        {[1, 2, 3].map((i) => (
          <div 
            key={i}
            className="h-24 bg-gray-800 animate-pulse rounded-lg"
          />
        ))}
      </div>
    );
  }

  if (vouchers.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-12 text-center">
        <p className="text-lg mb-2">No vouchers yet</p>
        <p className="text-sm text-gray-400">
          Claim a voucher code below to get started
        </p>
      </div>
    );
  }

  return (
    <div className="flex flex-col space-y-4">
      {vouchers.map((voucher) => (
        <VoucherCard
          key={voucher.id}
          voucher={voucher}
          onClick={() => onVoucherSelect(voucher)}
        />
      ))}
    </div>
  );
}
